import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useAuth } from '../module_roots/AuthContext';
import "../styles/Transaction.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faExchangeAlt,
    faMoneyBillWave,
    faUserFriends,
    faTruck,
    faHandshake,
    faUserTie,
    faShoppingCart,
    faMoneyCheck,
    faCoins,
    faCreditCard,
    faUniversity,
    faWallet,
    faRupeeSign,
    faDollarSign,
    faEuroSign,
    faPoundSign,
    faSearch,
    faCalendarAlt,
    faFilter,
    faPlus,
    faTrash,
    faSave,
    faTimes,
    faSpinner,
    faCheckCircle,
    faExclamationCircle,
    faExclamationTriangle,
    faReceipt,
    faPrint,
    faChevronRight,
    // faFilePdf,
    // faFileExcel,
    faChartLine,
    faChartPie,
    faChartBar,
    faHome,
    faBuilding,
    faStore,
    faBoxes,
    faBox,
    faTag,
    // faBarcode,
    faCalculator,
    faUndo,
    faRedo,
    faChevronDown,
    faChevronUp,
    faEye,
    faEyeSlash,
    faEdit,
    faCopy,
    faDownload,
    faUpload,
    faSync,
    faLock,
    faUnlock,
    faKey,
    faCog,
    faSlidersH,
    faList,
    faTh,
    faThLarge,
    faThList,
    faSort,
    faSortAmountDown,
    faSortAmountUp,
    faSortAlphaDown,
    faSortAlphaUp,
    faArrowsAlt,
    faExpand,
    faCompress,
    faMinus,
    faPlusCircle,
    faMinusCircle,
    faCheck,
    faBan,
    faClock,
    faHistory,
    faPercent,
    faRuler,
    faWeight,
    faBalanceScale,
    faTachometerAlt,
    faGauge,
    faBell,
    faEnvelope,
    faPhone,
    faMapMarkerAlt,
    faGlobe,
    faLanguage,
    faPalette,
    faMoon,
    faSun,
    faCloud,
    faCloudUploadAlt,
    faCloudDownloadAlt,
    faDatabase,
    faServer,
    faShieldAlt,
    faBug,
    faCode,
    faTerminal,
    faWindowMaximize,
    faWindowMinimize,
    faWindowRestore,
    faDesktop,
    faMobile,
    faTablet,
    faLaptop,
    faKeyboard,
    faMouse,
    faHeadphones,
    faMicrophone,
    faVideo,
    faCamera,
    faImage,
    faFile,
    faFileAlt,
    faFileArchive,
    faFileAudio,
    faFileCode,
    faFileImage,
    faFilePdf,
    faFilePowerpoint,
    faFileVideo,
    faFileWord,
    faFileExcel,
    faFolder,
    faFolderOpen,
    faFolderPlus,
    faFolderMinus,
    faTrashAlt,
    faArchive,
    faInbox,
    faOutbox,
    faPaperPlane,
    faSend,
    faReply,
    faShare,
    faShareAlt,
    faLink,
    faUnlink,
    faQrcode,
    faBarcode,
    faTicket,
    faTicketAlt,
    faGift,
    faGiftCard,
    faStar,
    faStarHalf,
    faStarHalfAlt,
    faHeart,
    faHeartBroken,
    faThumbsUp,
    faThumbsDown,
    faSmile,
    faFrown,
    faMeh,
    faAngry,
    faSadTear,
    faSadCry,
    faLaugh,
    faLaughSquint,
    faLaughWink,
    faGrin,
    faGrinTears,
    faGrinTongue,
    faGrinWink,
    faKiss,
    faKissBeam,
    faKissWinkHeart,
    faDizzy,
    faFlushed,
    faFrownOpen,
    faMehBlank,
    faMehRollingEyes,
    faSurprise,
    faTired
} from '@fortawesome/free-solid-svg-icons';

// ==============================================
// Transaction Types
// ==============================================
const TRANSACTION_TYPES = {
    CUSTOMER_PAYMENT: 'customer_payment',
    SUPPLIER_PAYMENT: 'supplier_payment',
    PARTNER_TRANSFER: 'partner_transfer',
    EXPENSE: 'expense',
    SALARY: 'salary',
    OWNER_TRANSFER: 'owner_transfer',
    COMMISSION: 'commission'
};

// ==============================================
// Payment Methods
// ==============================================
const PAYMENT_METHODS = [
    { value: 'cash', label: 'Cash', icon: faMoneyBillWave },
    { value: 'card', label: 'Card', icon: faCreditCard },
    { value: 'bank_transfer', label: 'Bank Transfer', icon: faUniversity },
    { value: 'cheque', label: 'Cheque', icon: faMoneyCheck },
    { value: 'upi', label: 'UPI', icon: faMobile },
    { value: 'wallet', label: 'Wallet', icon: faWallet }
];

// ==============================================
// Currency Icons
// ==============================================
const CURRENCY_ICONS = {
    INR: faRupeeSign,
    USD: faDollarSign,
    EUR: faEuroSign,
    GBP: faPoundSign,
    AED: faMoneyBillWave
};

// ==============================================
// Toast Notification Component
// ==============================================
const ToastNotification = ({ toast, setToast }) => {
    const getIconForType = (type) => {
        switch (type) {
            case 'success':
                return faCheckCircle;
            case 'error':
                return faExclamationCircle;
            case 'warning':
                return faExclamationTriangle;
            default:
                return faCheckCircle;
        }
    };

    const getTitleForType = (type) => {
        switch (type) {
            case 'success':
                return 'Success';
            case 'error':
                return 'Error';
            case 'warning':
                return 'Warning';
            default:
                return '';
        }
    };

    if (!toast.show) return null;

    const opacity = Math.max(toast.progress / 100, 0.1);

    return (
        <div
            className={`toast-notification ${toast.type}`}
            style={{ opacity }}
        >
            <div className="toast-content">
                <div className="toast-icon">
                    <FontAwesomeIcon icon={getIconForType(toast.type)} />
                </div>
                <div className="toast-text">
                    <div className="toast-title">
                        {getTitleForType(toast.type)}
                    </div>
                    <div className="toast-message">
                        {toast.message}
                    </div>
                </div>
                <button
                    className="toast-close"
                    onClick={() => setToast(prev => ({ ...prev, show: false }))}
                >
                    <FontAwesomeIcon icon={faTimes} />
                </button>
            </div>
            <div className="toast-timer">
                <div
                    className="toast-progress-bar"
                    style={{
                        width: `${toast.progress}%`,
                        transition: 'width 0.1s linear'
                    }}
                ></div>
                <div className="toast-countdown">
                    {toast.timeLeft}s
                </div>
            </div>
        </div>
    );
};

// ==============================================
// Account Selector Component
// ==============================================
const AccountSelector = ({
    type,
    value,
    onChange,
    accounts,
    loading,
    searchTerm,
    onSearch,
    placeholder,
    disabled,
    required,
    error,
    label
}) => {
    const [showDropdown, setShowDropdown] = useState(false);
    const [filteredAccounts, setFilteredAccounts] = useState([]);
    const dropdownRef = useRef(null);
    const inputRef = useRef(null);

    useEffect(() => {
        if (accounts && accounts.length > 0) {
            const filtered = accounts.filter(account => {
                const name = (account.name || account.customer_name || account.supplier_name || account.partner_name || '').toLowerCase();
                const phone = (account.phone || '').toLowerCase();
                const email = (account.email || '').toLowerCase();
                const search = searchTerm.toLowerCase();
                return name.includes(search) || phone.includes(search) || email.includes(search);
            });
            setFilteredAccounts(filtered);
        } else {
            setFilteredAccounts([]);
        }
    }, [accounts, searchTerm]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleSelect = (account) => {
        onChange({
            id: account.customer_id || account.supplier_id || account.partner_id || account.account_id,
            name: account.name || account.customer_name || account.supplier_name || account.partner_name,
            phone: account.phone,
            email: account.email,
            balance: account.current_balance,
            currency: account.currency_code,
            credit_limit: account.credit_limit,
            commission_rate: account.commission_rate
        });
        setShowDropdown(false);
    };

    return (
        <div className="account-selector-container" ref={dropdownRef}>
            <div className="input-container">
                <FontAwesomeIcon icon={faSearch} className="input-icon" />
                <input
                    type="text"
                    value={searchTerm}
                    onChange={(e) => {
                        onSearch(e.target.value);
                        if (!showDropdown) setShowDropdown(true);
                    }}
                    onFocus={() => setShowDropdown(true)}
                    placeholder=" "
                    disabled={disabled}
                    className={error ? 'error' : ''}
                    ref={inputRef}
                />
                <label className="input-label">
                    {placeholder || `Search ${type}...`}
                </label>
                {loading && (
                    <FontAwesomeIcon icon={faSpinner} spin className="loading-icon" />
                )}
            </div>
            
            {showDropdown && (
                <div className="account-dropdown">
                    {loading ? (
                        <div className="dropdown-loading">
                            <FontAwesomeIcon icon={faSpinner} spin />
                            <span>Loading...</span>
                        </div>
                    ) : filteredAccounts.length > 0 ? (
                        filteredAccounts.map((account) => (
                            <div
                                key={account.customer_id || account.supplier_id || account.partner_id || account.account_id}
                                className="account-item"
                                onClick={() => handleSelect(account)}
                            >
                                <div className="account-info">
                                    <span className="account-name">
                                        {account.name || account.customer_name || account.supplier_name || account.partner_name}
                                    </span>
                                    {account.phone && (
                                        <span className="account-phone">
                                            <FontAwesomeIcon icon={faPhone} size="xs" />
                                            {account.phone}
                                        </span>
                                    )}
                                </div>
                                {account.current_balance !== undefined && (
                                    <span className={`account-balance ${account.current_balance >= 0 ? 'positive' : 'negative'}`}>
                                        {account.currency_code || 'INR'} {parseFloat(account.current_balance).toFixed(2)}
                                    </span>
                                )}
                            </div>
                        ))
                    ) : (
                        <div className="dropdown-empty">
                            No {type} found
                        </div>
                    )}
                </div>
            )}
            
            {value && (
                <div className="selected-account">
                    <div className="selected-info">
                        <span className="selected-name">{value.name}</span>
                        {value.phone && (
                            <span className="selected-phone">
                                <FontAwesomeIcon icon={faPhone} size="xs" />
                                {value.phone}
                            </span>
                        )}
                    </div>
                    {value.balance !== undefined && (
                        <span className={`selected-balance ${value.balance >= 0 ? 'positive' : 'negative'}`}>
                            Balance: {value.currency || 'INR'} {parseFloat(value.balance).toFixed(2)}
                        </span>
                    )}
                </div>
            )}
            
            {error && (
                <div className="error-message-modern">
                    <FontAwesomeIcon icon={faExclamationTriangle} />
                    {error}
                </div>
            )}
        </div>
    );
};

// ==============================================
// Currency Selector Component
// ==============================================
const CurrencySelector = ({
    value,
    onChange,
    currencies,
    loading,
    disabled,
    error,
    showRate
}) => {
    const [exchangeRate, setExchangeRate] = useState(1.0000);
    const [baseCurrency, setBaseCurrency] = useState('INR');

    useEffect(() => {
        if (value && value !== baseCurrency) {
            fetchExchangeRate(value, baseCurrency);
        } else {
            setExchangeRate(1.0000);
        }
    }, [value]);

    const fetchExchangeRate = async (from, to) => {
        try {
            const response = await fetch('https://your-api.com/transactions.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    action: 'get_exchange_rate',
                    from_currency: from,
                    to_currency: to,
                    shop_id: localStorage.getItem('current_shop_id')
                })
            });
            const data = await response.json();
            if (data.status === 'success') {
                setExchangeRate(data.data.rate);
            }
        } catch (error) {
            console.error('Error fetching exchange rate:', error);
        }
    };

    return (
        <div className="currency-selector">
            <div className="currency-select-wrapper">
                <select
                    value={value || 'INR'}
                    onChange={(e) => onChange(e.target.value)}
                    disabled={disabled}
                    className={error ? 'error' : ''}
                >
                    {currencies.map((currency) => (
                        <option key={currency.currency_id} value={currency.currency_code}>
                            {currency.symbol} {currency.currency_code} - {currency.currency_name}
                        </option>
                    ))}
                </select>
                {loading && <FontAwesomeIcon icon={faSpinner} spin className="loading-icon" />}
            </div>
            
            {showRate && value && value !== baseCurrency && (
                <div className="exchange-rate-display">
                    <span>1 {value} = {exchangeRate} {baseCurrency}</span>
                </div>
            )}
            
            {error && (
                <div className="error-message-modern">
                    <FontAwesomeIcon icon={faExclamationTriangle} />
                    {error}
                </div>
            )}
        </div>
    );
};

// ==============================================
// Transaction Form Component
// ==============================================
const TransactionForm = ({
    type,
    onSubmit,
    onCancel,
    loading,
    shopId,
    username
}) => {
    const [formData, setFormData] = useState({
        transaction_number: '',
        transaction_date: new Date().toISOString().split('T')[0],
        from_account: null,
        to_account: null,
        amount: '',
        currency_code: 'INR',
        payment_method: 'cash',
        reference_number: '',
        description: '',
        commission_rate: '0.00',
        transfer_to_owner: true,
        notes: '',
        items: []
    });

    const [customers, setCustomers] = useState([]);
    const [suppliers, setSuppliers] = useState([]);
    const [partners, setPartners] = useState([]);
    const [currencies, setCurrencies] = useState([]);
    const [loadingCustomers, setLoadingCustomers] = useState(false);
    const [loadingSuppliers, setLoadingSuppliers] = useState(false);
    const [loadingPartners, setLoadingPartners] = useState(false);
    const [loadingCurrencies, setLoadingCurrencies] = useState(false);
    const [searchTerms, setSearchTerms] = useState({
        customer: '',
        supplier: '',
        partner: ''
    });
    const [errors, setErrors] = useState({});

    useEffect(() => {
        loadCurrencies();
        getNextTransactionNumber();
    }, []);

    useEffect(() => {
        if (type === TRANSACTION_TYPES.CUSTOMER_PAYMENT) {
            loadCustomers();
        } else if (type === TRANSACTION_TYPES.SUPPLIER_PAYMENT) {
            loadSuppliers();
        } else if (type === TRANSACTION_TYPES.PARTNER_TRANSFER) {
            loadPartners();
        }
    }, [type]);

    const getNextTransactionNumber = async () => {
        try {
            const response = await fetch('https://your-api.com/transactions.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    action: 'get_next_transaction_number',
                    shop_id: shopId,
                    transaction_type: type
                })
            });
            const data = await response.json();
            if (data.status === 'success') {
                setFormData(prev => ({
                    ...prev,
                    transaction_number: data.data.transaction_number
                }));
            }
        } catch (error) {
            console.error('Error getting transaction number:', error);
        }
    };

    const loadCustomers = async () => {
        setLoadingCustomers(true);
        try {
            const response = await fetch('https://your-api.com/transactions.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    action: 'get_customers',
                    shop_id: shopId,
                    search: searchTerms.customer
                })
            });
            const data = await response.json();
            if (data.status === 'success') {
                setCustomers(data.data);
            }
        } catch (error) {
            console.error('Error loading customers:', error);
        } finally {
            setLoadingCustomers(false);
        }
    };

    const loadSuppliers = async () => {
        setLoadingSuppliers(true);
        try {
            const response = await fetch('https://your-api.com/transactions.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    action: 'get_suppliers',
                    shop_id: shopId,
                    search: searchTerms.supplier
                })
            });
            const data = await response.json();
            if (data.status === 'success') {
                setSuppliers(data.data);
            }
        } catch (error) {
            console.error('Error loading suppliers:', error);
        } finally {
            setLoadingSuppliers(false);
        }
    };

    const loadPartners = async () => {
        setLoadingPartners(true);
        try {
            const response = await fetch('https://your-api.com/transactions.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    action: 'get_partners',
                    shop_id: shopId,
                    search: searchTerms.partner
                })
            });
            const data = await response.json();
            if (data.status === 'success') {
                setPartners(data.data);
            }
        } catch (error) {
            console.error('Error loading partners:', error);
        } finally {
            setLoadingPartners(false);
        }
    };

    const loadCurrencies = async () => {
        setLoadingCurrencies(true);
        try {
            const response = await fetch('https://your-api.com/transactions.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    action: 'get_currencies',
                    shop_id: shopId
                })
            });
            const data = await response.json();
            if (data.status === 'success') {
                setCurrencies(data.data);
            }
        } catch (error) {
            console.error('Error loading currencies:', error);
        } finally {
            setLoadingCurrencies(false);
        }
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
        
        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: '' }));
        }
    };

    const validateForm = () => {
        const newErrors = {};

        if (!formData.amount || parseFloat(formData.amount) <= 0) {
            newErrors.amount = 'Please enter a valid amount';
        }

        if (type === TRANSACTION_TYPES.CUSTOMER_PAYMENT && !formData.from_account) {
            newErrors.from_account = 'Please select a customer';
        }

        if (type === TRANSACTION_TYPES.SUPPLIER_PAYMENT && !formData.to_account) {
            newErrors.to_account = 'Please select a supplier';
        }

        if (type === TRANSACTION_TYPES.PARTNER_TRANSFER) {
            if (!formData.to_account) {
                newErrors.to_account = 'Please select a partner';
            }
            if (parseFloat(formData.commission_rate) < 0) {
                newErrors.commission_rate = 'Commission rate cannot be negative';
            }
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        const payload = {
            action: 'add_transaction',
            transaction_type: type,
            shop_id: shopId,
            username: username,
            amount: parseFloat(formData.amount),
            currency_code: formData.currency_code,
            payment_method: formData.payment_method,
            reference_number: formData.reference_number,
            description: formData.description,
            notes: formData.notes,
            transfer_to_owner: formData.transfer_to_owner,
            transaction_date: formData.transaction_date + ' ' + new Date().toLocaleTimeString('en-IN', { hour12: false })
        };

        if (type === TRANSACTION_TYPES.CUSTOMER_PAYMENT) {
            payload.from_account_type = 'customer';
            payload.from_account_id = formData.from_account.id;
            payload.from_account_name = formData.from_account.name;
            payload.to_account_type = 'cash';
            payload.to_account_id = 0;
            payload.to_account_name = 'Cash';
        } else if (type === TRANSACTION_TYPES.SUPPLIER_PAYMENT) {
            payload.from_account_type = 'cash';
            payload.from_account_id = 0;
            payload.from_account_name = 'Cash';
            payload.to_account_type = 'supplier';
            payload.to_account_id = formData.to_account.id;
            payload.to_account_name = formData.to_account.name;
        } else if (type === TRANSACTION_TYPES.PARTNER_TRANSFER) {
            payload.from_account_type = 'cash';
            payload.from_account_id = 0;
            payload.from_account_name = 'Cash';
            payload.to_account_type = 'partner';
            payload.to_account_id = formData.to_account.id;
            payload.to_account_name = formData.to_account.name;
            payload.commission_rate = parseFloat(formData.commission_rate);
            payload.commission_amount = (parseFloat(formData.amount) * parseFloat(formData.commission_rate)) / 100;
        }

        onSubmit(payload);
    };

    const renderAccountFields = () => {
        switch (type) {
            case TRANSACTION_TYPES.CUSTOMER_PAYMENT:
                return (
                    <>
                        <div className="form-group-modern">
                            <label className="form-label">From (Customer) *</label>
                            <AccountSelector
                                type="customer"
                                value={formData.from_account}
                                onChange={(account) => setFormData(prev => ({ ...prev, from_account: account }))}
                                accounts={customers}
                                loading={loadingCustomers}
                                searchTerm={searchTerms.customer}
                                onSearch={(term) => {
                                    setSearchTerms(prev => ({ ...prev, customer: term }));
                                    loadCustomers();
                                }}
                                placeholder="Search customer..."
                                disabled={loading}
                                required
                                error={errors.from_account}
                            />
                        </div>
                        
                        <div className="form-group-modern">
                            <label className="form-label">To (Cash/Account)</label>
                            <div className="readonly-field">
                                <FontAwesomeIcon icon={faBuilding} />
                                <span>Cash / Bank Account</span>
                            </div>
                        </div>
                    </>
                );

            case TRANSACTION_TYPES.SUPPLIER_PAYMENT:
                return (
                    <>
                        <div className="form-group-modern">
                            <label className="form-label">From (Cash/Account)</label>
                            <div className="readonly-field">
                                <FontAwesomeIcon icon={faBuilding} />
                                <span>Cash / Bank Account</span>
                            </div>
                        </div>
                        
                        <div className="form-group-modern">
                            <label className="form-label">To (Supplier) *</label>
                            <AccountSelector
                                type="supplier"
                                value={formData.to_account}
                                onChange={(account) => setFormData(prev => ({ ...prev, to_account: account }))}
                                accounts={suppliers}
                                loading={loadingSuppliers}
                                searchTerm={searchTerms.supplier}
                                onSearch={(term) => {
                                    setSearchTerms(prev => ({ ...prev, supplier: term }));
                                    loadSuppliers();
                                }}
                                placeholder="Search supplier..."
                                disabled={loading}
                                required
                                error={errors.to_account}
                            />
                        </div>
                    </>
                );

            case TRANSACTION_TYPES.PARTNER_TRANSFER:
                return (
                    <>
                        <div className="form-group-modern">
                            <label className="form-label">From (Cash/Account)</label>
                            <div className="readonly-field">
                                <FontAwesomeIcon icon={faBuilding} />
                                <span>Cash / Bank Account</span>
                            </div>
                        </div>
                        
                        <div className="form-group-modern">
                            <label className="form-label">To (Partner) *</label>
                            <AccountSelector
                                type="partner"
                                value={formData.to_account}
                                onChange={(account) => setFormData(prev => ({ ...prev, to_account: account }))}
                                accounts={partners}
                                loading={loadingPartners}
                                searchTerm={searchTerms.partner}
                                onSearch={(term) => {
                                    setSearchTerms(prev => ({ ...prev, partner: term }));
                                    loadPartners();
                                }}
                                placeholder="Search partner..."
                                disabled={loading}
                                required
                                error={errors.to_account}
                            />
                        </div>

                        {formData.to_account && (
                            <div className="form-group-modern">
                                <label className="form-label">Commission Rate (%)</label>
                                <div className="input-container">
                                    <FontAwesomeIcon icon={faPercent} className="input-icon" />
                                    <input
                                        type="number"
                                        name="commission_rate"
                                        value={formData.commission_rate}
                                        onChange={handleChange}
                                        step="0.01"
                                        min="0"
                                        max="100"
                                        placeholder="0.00"
                                        disabled={loading}
                                    />
                                    <label className="input-label">Commission Rate (%)</label>
                                </div>
                                {errors.commission_rate && (
                                    <div className="error-message-modern">
                                        <FontAwesomeIcon icon={faExclamationTriangle} />
                                        {errors.commission_rate}
                                    </div>
                                )}
                                {parseFloat(formData.commission_rate) > 0 && (
                                    <div className="commission-preview">
                                        Commission Amount: {formData.currency_code} {(parseFloat(formData.amount || 0) * parseFloat(formData.commission_rate) / 100).toFixed(2)}
                                    </div>
                                )}
                            </div>
                        )}
                    </>
                );

            default:
                return null;
        }
    };

    return (
        <form onSubmit={handleSubmit} className="transaction-form">
            <div className="form-section">
                <div className="section-header">
                    <h3 className="section-title">
                        <FontAwesomeIcon icon={faExchangeAlt} />
                        Transaction Details
                    </h3>
                </div>

                <div className="form-grid-modern">
                    <div className="form-group-modern">
                        <div className="input-container">
                            <FontAwesomeIcon icon={faReceipt} className="input-icon" />
                            <input
                                type="text"
                                value={formData.transaction_number}
                                readOnly
                                className="readonly-input"
                                placeholder=" "
                            />
                            <label className="input-label">Transaction Number</label>
                        </div>
                    </div>

                    <div className="form-group-modern">
                        <div className="input-container">
                            <FontAwesomeIcon icon={faCalendarAlt} className="input-icon" />
                            <input
                                type="date"
                                name="transaction_date"
                                value={formData.transaction_date}
                                onChange={handleChange}
                                disabled={loading}
                                placeholder=" "
                            />
                            <label className="input-label">Transaction Date</label>
                        </div>
                    </div>
                </div>
            </div>

            <div className="form-section">
                <div className="section-header">
                    <h3 className="section-title">
                        <FontAwesomeIcon icon={faUserFriends} />
                        Account Details
                    </h3>
                </div>

                <div className="form-grid-modern">
                    {renderAccountFields()}
                </div>
            </div>

            <div className="form-section">
                <div className="section-header">
                    <h3 className="section-title">
                        <FontAwesomeIcon icon={faCoins} />
                        Payment Details
                    </h3>
                </div>

                <div className="form-grid-modern">
                    <div className="form-group-modern">
                        <div className="input-container">
                            <FontAwesomeIcon icon={CURRENCY_ICONS[formData.currency_code] || faRupeeSign} className="input-icon" />
                            <input
                                type="number"
                                name="amount"
                                value={formData.amount}
                                onChange={handleChange}
                                step="0.01"
                                min="0.01"
                                placeholder=" "
                                disabled={loading}
                                className={errors.amount ? 'error' : ''}
                            />
                            <label className="input-label">Amount *</label>
                        </div>
                        {errors.amount && (
                            <div className="error-message-modern">
                                <FontAwesomeIcon icon={faExclamationTriangle} />
                                {errors.amount}
                            </div>
                        )}
                    </div>

                    <div className="form-group-modern">
                        <label className="form-label">Currency</label>
                        <CurrencySelector
                            value={formData.currency_code}
                            onChange={(currency) => setFormData(prev => ({ ...prev, currency_code: currency }))}
                            currencies={currencies}
                            loading={loadingCurrencies}
                            disabled={loading}
                            showRate={true}
                        />
                    </div>

                    <div className="form-group-modern">
                        <label className="form-label">Payment Method</label>
                        <div className="payment-method-selector">
                            {PAYMENT_METHODS.map(method => (
                                <button
                                    key={method.value}
                                    type="button"
                                    className={`payment-method-btn ${formData.payment_method === method.value ? 'active' : ''}`}
                                    onClick={() => setFormData(prev => ({ ...prev, payment_method: method.value }))}
                                    disabled={loading}
                                >
                                    <FontAwesomeIcon icon={method.icon} />
                                    <span>{method.label}</span>
                                </button>
                            ))}
                        </div>
                    </div>

                    <div className="form-group-modern">
                        <div className="input-container">
                            <FontAwesomeIcon icon={faTag} className="input-icon" />
                            <input
                                type="text"
                                name="reference_number"
                                value={formData.reference_number}
                                onChange={handleChange}
                                placeholder=" "
                                disabled={loading}
                            />
                            <label className="input-label">Reference Number (Cheque/Transaction ID)</label>
                        </div>
                    </div>

                    <div className="form-group-modern full-width">
                        <div className="input-container">
                            <FontAwesomeIcon icon={faFile} className="input-icon" />
                            <textarea
                                name="description"
                                value={formData.description}
                                onChange={handleChange}
                                placeholder=" "
                                disabled={loading}
                                rows="2"
                            ></textarea>
                            <label className="input-label">Description</label>
                        </div>
                    </div>

                    <div className="form-group-modern full-width">
                        <div className="input-container">
                            <FontAwesomeIcon icon={faFileAlt} className="input-icon" />
                            <textarea
                                name="notes"
                                value={formData.notes}
                                onChange={handleChange}
                                placeholder=" "
                                disabled={loading}
                                rows="2"
                            ></textarea>
                            <label className="input-label">Additional Notes</label>
                        </div>
                    </div>
                </div>

                <div className="form-options">
                    <label className="checkbox-container">
                        <input
                            type="checkbox"
                            name="transfer_to_owner"
                            checked={formData.transfer_to_owner}
                            onChange={handleChange}
                            disabled={loading}
                        />
                        <span className="checkbox-label">
                            <FontAwesomeIcon icon={faUserTie} />
                            Automatically transfer remaining balance to owner account
                        </span>
                    </label>
                </div>
            </div>

            <div className="form-actions-modern">
                <button
                    type="button"
                    className="btn-modern btn-secondary-modern"
                    onClick={onCancel}
                    disabled={loading}
                >
                    <FontAwesomeIcon icon={faTimes} />
                    <span>Cancel</span>
                </button>
                <button
                    type="submit"
                    className="btn-modern btn-primary-modern"
                    disabled={loading}
                >
                    {loading ? (
                        <>
                            <div className="btn-spinner"></div>
                            <span>Processing...</span>
                        </>
                    ) : (
                        <>
                            <span>Process Transaction</span>
                            <FontAwesomeIcon icon={faSave} />
                        </>
                    )}
                </button>
            </div>
        </form>
    );
};

// ==============================================
// Account Summary Cards Component
// ==============================================
const AccountSummaryCards = ({ summary, loading }) => {
    if (loading) {
        return (
            <div className="summary-loading">
                <FontAwesomeIcon icon={faSpinner} spin />
                <span>Loading summary...</span>
            </div>
        );
    }

    return (
        <div className="summary-cards">
            <div className="summary-card customers">
                <div className="card-icon">
                    <FontAwesomeIcon icon={faUserFriends} />
                </div>
                <div className="card-content">
                    <span className="card-label">Customers</span>
                    <span className="card-value">₹ {summary.customers?.total_balance?.toFixed(2) || '0.00'}</span>
                    <span className="card-count">{summary.customers?.count || 0} accounts</span>
                </div>
            </div>

            <div className="summary-card suppliers">
                <div className="card-icon">
                    <FontAwesomeIcon icon={faTruck} />
                </div>
                <div className="card-content">
                    <span className="card-label">Suppliers</span>
                    <span className="card-value">₹ {summary.suppliers?.total_balance?.toFixed(2) || '0.00'}</span>
                    <span className="card-count">{summary.suppliers?.count || 0} accounts</span>
                </div>
            </div>

            <div className="summary-card partners">
                <div className="card-icon">
                    <FontAwesomeIcon icon={faHandshake} />
                </div>
                <div className="card-content">
                    <span className="card-label">Partners</span>
                    <span className="card-value">₹ {summary.partners?.total_balance?.toFixed(2) || '0.00'}</span>
                    <span className="card-count">{summary.partners?.count || 0} accounts</span>
                </div>
            </div>

            <div className="summary-card owner">
                <div className="card-icon">
                    <FontAwesomeIcon icon={faUserTie} />
                </div>
                <div className="card-content">
                    <span className="card-label">Owner Balance</span>
                    <span className="card-value">₹ {summary.owner?.balance?.toFixed(2) || '0.00'}</span>
                    <span className="card-count">Income: ₹ {summary.owner?.total_income?.toFixed(2) || '0.00'}</span>
                </div>
            </div>

            <div className="summary-card today">
                <div className="card-icon">
                    <FontAwesomeIcon icon={faCalendarAlt} />
                </div>
                <div className="card-content">
                    <span className="card-label">Today's Transactions</span>
                    <span className="card-value">₹ {summary.today_transactions?.total_base_amount?.toFixed(2) || '0.00'}</span>
                    <span className="card-count">{summary.today_transactions?.count || 0} transactions</span>
                </div>
            </div>

            <div className="summary-card commissions">
                <div className="card-icon">
                    <FontAwesomeIcon icon={faPercent} />
                </div>
                <div className="card-content">
                    <span className="card-label">Pending Commissions</span>
                    <span className="card-value">₹ {summary.pending_commissions?.total_amount?.toFixed(2) || '0.00'}</span>
                    <span className="card-count">{summary.pending_commissions?.count || 0} pending</span>
                </div>
            </div>
        </div>
    );
};

// ==============================================
// Transactions Table Component
// ==============================================
const TransactionsTable = ({ transactions, loading, onView, onPrint }) => {
    const getTypeIcon = (type) => {
        switch (type) {
            case TRANSACTION_TYPES.CUSTOMER_PAYMENT:
                return { icon: faUserFriends, color: '#10b981' };
            case TRANSACTION_TYPES.SUPPLIER_PAYMENT:
                return { icon: faTruck, color: '#f59e0b' };
            case TRANSACTION_TYPES.PARTNER_TRANSFER:
                return { icon: faHandshake, color: '#6366f1' };
            case TRANSACTION_TYPES.EXPENSE:
                return { icon: faMoneyBillWave, color: '#ef4444' };
            case TRANSACTION_TYPES.SALARY:
                return { icon: faMoneyCheck, color: '#8b5cf6' };
            case TRANSACTION_TYPES.OWNER_TRANSFER:
                return { icon: faUserTie, color: '#ec4899' };
            case TRANSACTION_TYPES.COMMISSION:
                return { icon: faPercent, color: '#14b8a6' };
            default:
                return { icon: faExchangeAlt, color: '#6b7280' };
        }
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-IN', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    if (loading) {
        return (
            <div className="table-loading">
                <FontAwesomeIcon icon={faSpinner} spin />
                <span>Loading transactions...</span>
            </div>
        );
    }

    if (!transactions || transactions.length === 0) {
        return (
            <div className="table-empty">
                <FontAwesomeIcon icon={faExchangeAlt} />
                <h3>No Transactions Found</h3>
                <p>Start by creating a new transaction</p>
            </div>
        );
    }

    return (
        <div className="transactions-table-container">
            <table className="transactions-table">
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>Transaction #</th>
                        <th>Type</th>
                        <th>From</th>
                        <th>To</th>
                        <th>Amount</th>
                        <th>Status</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {transactions.map((transaction) => {
                        const typeInfo = getTypeIcon(transaction.transaction_type);
                        return (
                            <tr key={transaction.transaction_id}>
                                <td>{formatDate(transaction.transaction_date)}</td>
                                <td>
                                    <span className="transaction-number">
                                        {transaction.transaction_number}
                                    </span>
                                </td>
                                <td>
                                    <span className="transaction-type" style={{ color: typeInfo.color }}>
                                        <FontAwesomeIcon icon={typeInfo.icon} />
                                        {transaction.transaction_type.replace('_', ' ').toUpperCase()}
                                    </span>
                                </td>
                                <td>
                                    <div className="account-info">
                                        <span className="account-type">{transaction.from_account_type}</span>
                                        <span className="account-name">{transaction.from_account_name}</span>
                                    </div>
                                </td>
                                <td>
                                    <div className="account-info">
                                        <span className="account-type">{transaction.to_account_type}</span>
                                        <span className="account-name">{transaction.to_account_name}</span>
                                    </div>
                                </td>
                                <td>
                                    <span className={`transaction-amount ${transaction.amount >= 0 ? 'positive' : 'negative'}`}>
                                        {transaction.currency_code} {parseFloat(transaction.amount).toFixed(2)}
                                    </span>
                                    {transaction.base_amount !== transaction.amount && (
                                        <small className="base-amount">
                                            (Base: ₹ {parseFloat(transaction.base_amount).toFixed(2)})
                                        </small>
                                    )}
                                </td>
                                <td>
                                    <span className={`status-badge ${transaction.payment_status}`}>
                                        {transaction.payment_status}
                                    </span>
                                    {transaction.settlement_status !== 'settled' && (
                                        <span className={`status-badge small ${transaction.settlement_status}`}>
                                            {transaction.settlement_status}
                                        </span>
                                    )}
                                </td>
                                <td>
                                    <button
                                        className="action-btn view"
                                        onClick={() => onView(transaction)}
                                        title="View Details"
                                    >
                                        <FontAwesomeIcon icon={faEye} />
                                    </button>
                                    <button
                                        className="action-btn print"
                                        onClick={() => onPrint(transaction)}
                                        title="Print Receipt"
                                    >
                                        <FontAwesomeIcon icon={faPrint} />
                                    </button>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

// ==============================================
// Main Transactions Component
// ==============================================
const Transactions = () => {
    const { user, currentShop } = useAuth();

    const [shopId, setShopId] = useState(() => {
        if (user?.shop_id) {
            return user.shop_id;
        }
        return localStorage.getItem('current_shop_id') || '';
    });

    const [activeTab, setActiveTab] = useState('dashboard');
    const [transactionType, setTransactionType] = useState(TRANSACTION_TYPES.CUSTOMER_PAYMENT);
    const [showForm, setShowForm] = useState(false);
    const [transactions, setTransactions] = useState([]);
    const [summary, setSummary] = useState({});
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const [filters, setFilters] = useState({
        from_date: '',
        to_date: '',
        transaction_type: '',
        payment_status: '',
        search: ''
    });

    // Toast state
    const [toast, setToast] = useState({
        show: false,
        type: '',
        message: '',
        progress: 100,
        timeLeft: 3
    });

    const toastTimerRef = useRef(null);

    // Load data on mount and when shop changes
    useEffect(() => {
        if (shopId && user?.username) {
            loadSummary();
            loadTransactions();
        }
    }, [shopId, user?.username]);

    // Show toast function
    const showToast = useCallback((type, message) => {
        if (toastTimerRef.current) {
            clearInterval(toastTimerRef.current);
        }

        setToast({
            show: true,
            type,
            message,
            progress: 100,
            timeLeft: 3
        });

        let timeLeft = 3;
        const timer = setInterval(() => {
            timeLeft -= 0.1;
            const progress = (timeLeft / 3) * 100;

            setToast(prev => ({
                ...prev,
                progress,
                timeLeft: parseFloat(timeLeft.toFixed(1))
            }));

            if (timeLeft <= 0) {
                clearInterval(timer);
                setToast(prev => ({ ...prev, show: false }));
            }
        }, 100);

        toastTimerRef.current = timer;
    }, []);

    // Clean up timer
    useEffect(() => {
        return () => {
            if (toastTimerRef.current) {
                clearInterval(toastTimerRef.current);
            }
        };
    }, []);

    const loadSummary = async () => {
        try {
            const response = await fetch('https://your-api.com/transactions.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    action: 'get_account_summary',
                    shop_id: shopId
                })
            });
            const data = await response.json();
            if (data.status === 'success') {
                setSummary(data.data);
            }
        } catch (error) {
            console.error('Error loading summary:', error);
        }
    };

    const loadTransactions = async () => {
        setLoading(true);
        try {
            const response = await fetch('https://your-api.com/transactions.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    action: 'get_transactions',
                    shop_id: shopId,
                    filters: filters
                })
            });
            const data = await response.json();
            if (data.status === 'success') {
                setTransactions(data.data);
            }
        } catch (error) {
            console.error('Error loading transactions:', error);
            showToast('error', 'Failed to load transactions');
        } finally {
            setLoading(false);
        }
    };

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({ ...prev, [name]: value }));
    };

    const applyFilters = () => {
        loadTransactions();
    };

    const resetFilters = () => {
        setFilters({
            from_date: '',
            to_date: '',
            transaction_type: '',
            payment_status: '',
            search: ''
        });
        setTimeout(() => {
            loadTransactions();
        }, 100);
    };

    const handleSubmitTransaction = async (data) => {
        setSaving(true);
        try {
            const response = await fetch('https://your-api.com/transactions.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data)
            });
            const result = await response.json();
            
            if (result.status === 'success') {
                showToast('success', 'Transaction processed successfully!');
                setShowForm(false);
                loadSummary();
                loadTransactions();
            } else {
                showToast('error', result.message || 'Failed to process transaction');
            }
        } catch (error) {
            console.error('Error submitting transaction:', error);
            showToast('error', 'Network error occurred');
        } finally {
            setSaving(false);
        }
    };

    const handleViewTransaction = (transaction) => {
        // Implement view details modal
        console.log('View transaction:', transaction);
    };

    const handlePrintReceipt = (transaction) => {
        // Implement print receipt
        console.log('Print receipt for:', transaction);
    };

    const renderContent = () => {
        switch (activeTab) {
            case 'dashboard':
                return (
                    <div className="dashboard-content">
                        <AccountSummaryCards summary={summary} loading={loading} />
                        
                        <div className="recent-transactions">
                            <div className="section-header">
                                <h3 className="section-title">
                                    <FontAwesomeIcon icon={faHistory} />
                                    Recent Transactions
                                </h3>
                                <button
                                    className="btn-link"
                                    onClick={() => setActiveTab('transactions')}
                                >
                                    View All
                                    <FontAwesomeIcon icon={faChevronRight} />
                                </button>
                            </div>
                            <TransactionsTable
                                transactions={transactions.slice(0, 10)}
                                loading={loading}
                                onView={handleViewTransaction}
                                onPrint={handlePrintReceipt}
                            />
                        </div>
                    </div>
                );

            case 'transactions':
                return (
                    <div className="transactions-content">
                        <div className="filters-section">
                            <div className="filters-grid">
                                <div className="filter-group">
                                    <label>From Date</label>
                                    <input
                                        type="date"
                                        name="from_date"
                                        value={filters.from_date}
                                        onChange={handleFilterChange}
                                    />
                                </div>
                                <div className="filter-group">
                                    <label>To Date</label>
                                    <input
                                        type="date"
                                        name="to_date"
                                        value={filters.to_date}
                                        onChange={handleFilterChange}
                                    />
                                </div>
                                <div className="filter-group">
                                    <label>Type</label>
                                    <select
                                        name="transaction_type"
                                        value={filters.transaction_type}
                                        onChange={handleFilterChange}
                                    >
                                        <option value="">All Types</option>
                                        <option value={TRANSACTION_TYPES.CUSTOMER_PAYMENT}>Customer Payment</option>
                                        <option value={TRANSACTION_TYPES.SUPPLIER_PAYMENT}>Supplier Payment</option>
                                        <option value={TRANSACTION_TYPES.PARTNER_TRANSFER}>Partner Transfer</option>
                                        <option value={TRANSACTION_TYPES.EXPENSE}>Expense</option>
                                        <option value={TRANSACTION_TYPES.SALARY}>Salary</option>
                                        <option value={TRANSACTION_TYPES.OWNER_TRANSFER}>Owner Transfer</option>
                                        <option value={TRANSACTION_TYPES.COMMISSION}>Commission</option>
                                    </select>
                                </div>
                                <div className="filter-group">
                                    <label>Status</label>
                                    <select
                                        name="payment_status"
                                        value={filters.payment_status}
                                        onChange={handleFilterChange}
                                    >
                                        <option value="">All Status</option>
                                        <option value="pending">Pending</option>
                                        <option value="completed">Completed</option>
                                        <option value="failed">Failed</option>
                                        <option value="cancelled">Cancelled</option>
                                    </select>
                                </div>
                                <div className="filter-group search-group">
                                    <input
                                        type="text"
                                        name="search"
                                        value={filters.search}
                                        onChange={handleFilterChange}
                                        placeholder="Search by number, account, reference..."
                                    />
                                    <button className="search-btn" onClick={applyFilters}>
                                        <FontAwesomeIcon icon={faSearch} />
                                    </button>
                                    <button className="reset-btn" onClick={resetFilters}>
                                        <FontAwesomeIcon icon={faUndo} />
                                    </button>
                                </div>
                            </div>
                        </div>

                        <TransactionsTable
                            transactions={transactions}
                            loading={loading}
                            onView={handleViewTransaction}
                            onPrint={handlePrintReceipt}
                        />
                    </div>
                );

            case 'reports':
                return (
                    <div className="reports-content">
                        <h3>Reports Coming Soon</h3>
                        <p>Transaction reports and analytics will be available here</p>
                    </div>
                );

            default:
                return null;
        }
    };

    return (
        <div className="transactions-module">
            <ToastNotification toast={toast} setToast={setToast} />

            <div className="module-header">
                <div className="header-content">
                    <div className="header-icon">
                        <FontAwesomeIcon icon={faExchangeAlt} />
                    </div>
                    <div className="header-text">
                        <h1>Transaction Management</h1>
                        <p>Manage all financial transactions in one place</p>
                    </div>
                </div>
                <button
                    className="btn-primary"
                    onClick={() => setShowForm(true)}
                >
                    <FontAwesomeIcon icon={faPlus} />
                    New Transaction
                </button>
            </div>

            <div className="module-tabs">
                <button
                    className={`tab-btn ${activeTab === 'dashboard' ? 'active' : ''}`}
                    onClick={() => setActiveTab('dashboard')}
                >
                    <FontAwesomeIcon icon={faHome} />
                    Dashboard
                </button>
                <button
                    className={`tab-btn ${activeTab === 'transactions' ? 'active' : ''}`}
                    onClick={() => setActiveTab('transactions')}
                >
                    <FontAwesomeIcon icon={faList} />
                    Transactions
                </button>
                <button
                    className={`tab-btn ${activeTab === 'reports' ? 'active' : ''}`}
                    onClick={() => setActiveTab('reports')}
                >
                    <FontAwesomeIcon icon={faChartLine} />
                    Reports
                </button>
            </div>

            <div className="type-selector">
                <span className="selector-label">Transaction Type:</span>
                <div className="type-buttons">
                    <button
                        className={`type-btn ${transactionType === TRANSACTION_TYPES.CUSTOMER_PAYMENT ? 'active' : ''}`}
                        onClick={() => setTransactionType(TRANSACTION_TYPES.CUSTOMER_PAYMENT)}
                    >
                        <FontAwesomeIcon icon={faUserFriends} />
                        Customer Payment
                    </button>
                    <button
                        className={`type-btn ${transactionType === TRANSACTION_TYPES.SUPPLIER_PAYMENT ? 'active' : ''}`}
                        onClick={() => setTransactionType(TRANSACTION_TYPES.SUPPLIER_PAYMENT)}
                    >
                        <FontAwesomeIcon icon={faTruck} />
                        Supplier Payment
                    </button>
                    <button
                        className={`type-btn ${transactionType === TRANSACTION_TYPES.PARTNER_TRANSFER ? 'active' : ''}`}
                        onClick={() => setTransactionType(TRANSACTION_TYPES.PARTNER_TRANSFER)}
                    >
                        <FontAwesomeIcon icon={faHandshake} />
                        Partner Transfer
                    </button>
                    <button
                        className={`type-btn ${transactionType === TRANSACTION_TYPES.EXPENSE ? 'active' : ''}`}
                        onClick={() => setTransactionType(TRANSACTION_TYPES.EXPENSE)}
                    >
                        <FontAwesomeIcon icon={faMoneyBillWave} />
                        Expense
                    </button>
                    <button
                        className={`type-btn ${transactionType === TRANSACTION_TYPES.SALARY ? 'active' : ''}`}
                        onClick={() => setTransactionType(TRANSACTION_TYPES.SALARY)}
                    >
                        <FontAwesomeIcon icon={faMoneyCheck} />
                        Salary
                    </button>
                </div>
            </div>

            {renderContent()}

            {showForm && (
                <div className="modal-overlay" onClick={() => setShowForm(false)}>
                    <div className="modal-content large" onClick={e => e.stopPropagation()}>
                        <div className="modal-header">
                            <h3>
                                <FontAwesomeIcon icon={faExchangeAlt} />
                                New {transactionType.replace('_', ' ').toUpperCase()}
                            </h3>
                            <button className="modal-close" onClick={() => setShowForm(false)}>
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>
                        <div className="modal-body">
                            <TransactionForm
                                type={transactionType}
                                onSubmit={handleSubmitTransaction}
                                onCancel={() => setShowForm(false)}
                                loading={saving}
                                shopId={shopId}
                                username={user?.username}
                            />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Transactions;